import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHeart2"><Path d="M12.489 21.3725C21.0169 16.5927 23.115 10.9028 21.5108 6.90294C20.732 4.96087 19.0972 3.56916 17.1692 3.13926C15.4716 2.76077 13.6166 3.14222 12 4.42553C10.3834 3.14222 8.52833 2.76077 6.83081 3.13927C4.90275 3.56917 3.26802 4.96089 2.48916 6.90295C0.885016 10.9029 2.98318 16.5927 11.5111 21.3725L12 21.6466L12.489 21.3725Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeart2;
